export const isIE11 = (): boolean => {
  return /rv:11.0/i.test(window.navigator.userAgent);
};

export const isEdge = (): boolean => {
  return /Edge\/\d./i.test(window.navigator.userAgent);
};
